import { Either } from "../core/Either";
import { Result } from "../core/Result";
import { APIResponse } from "../models/APIResponse";

/** Turn APIResponse<T> (Either<string, Result<T>>) into T or throw Error */
export function unwrapApi<T>(resp: APIResponse<T>): T {
  // Either<L, A> has isLeft/isRight on the instance
  if ((resp as Either<string, Result<T>>).isLeft()) {
    // Left.value is the string error
    const l = resp.value as string;
    throw new Error(l);
  }

  const result = resp.value as Result<T>;
  if (result.isFailure) {
    throw new Error(String(result.error));
  }
  return result.getValue();
}

export async function unwrapApiP<T>(p: Promise<APIResponse<T>>): Promise<T> {
  return unwrapApi(await p);
}
